"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _transactableModal = require("../shared-components/modal/transactable-modal");
var _searchFormNav = require("./search-form-nav");
var _searchSubmitHoc = _interopRequireDefault(require("../elements-search-module/search-submit-hoc"));
var _reactIntl = require("react-intl");
var _sharedIntlProviderHOC = _interopRequireDefault(require("../shared-components/hocs/sharedIntlProviderHOC"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /* eslint new-cap: 0 */ /* global PSSessions, analyticsIntegrations */
var SearchModal = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchModal, _React$Component);
  function SearchModal(props) {
    _classCallCheck(this, SearchModal);
    return _callSuper(this, SearchModal, [props]);
  }
  _createClass(SearchModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      analyticsIntegrations.whichModalOpened('Search Modal');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      SearchModal.updateHash();
    }
  }, {
    key: "closeBehavior",
    value: function closeBehavior() {
      $('#modal-container').modal('hide');
      return _reactDom.default.unmountComponentAtNode(document.getElementById('modal-container'));
    }
  }, {
    key: "render",
    value: function render() {
      var Search = (0, _searchSubmitHoc.default)(_searchFormNav.SearchFormNav);
      return /*#__PURE__*/_react.default.createElement(_transactableModal.Modal, {
        show: true,
        addCloseIcon: true,
        modalType: "standard",
        modalID: "search-modal",
        modalSize: 'sm-size',
        body: /*#__PURE__*/_react.default.createElement(Search, null),
        header: this.props.intl.formatMessage({
          id: 'search_modal.search_modal.find_space',
          defaultMessage: 'Find a Space'
        }),
        footer: null,
        closeBehavior: this.closeBehavior
      });
    }
  }], [{
    key: "updateHash",
    value: function updateHash() {
      location.hash = '';
    }
  }, {
    key: "openSearchModal",
    value: function openSearchModal() {
      var OpenSearchModal = (0, _reactIntl.injectIntl)(SearchModal);
      return _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_sharedIntlProviderHOC.default, null, /*#__PURE__*/_react.default.createElement(OpenSearchModal, null)), document.getElementById('modal-container'));
    }
  }]);
  return SearchModal;
}(_react.default.Component);
exports.SearchModal = SearchModal;